import React from "react";
import { Link } from "react-router-dom";
import { ShieldOff } from "lucide-react";

/**
 * Affiché lorsque l’API renvoie 403 ou que le rôle ne permet pas le module finance.
 */
export default function FinanceAccessDenied({
  title = "Accès refusé",
  detail = "Vous n’avez pas les droits nécessaires pour ce module, ou l’API a refusé l’opération.",
}: {
  title?: string;
  detail?: string;
}): React.JSX.Element {
  return (
    <div className="flex min-h-[420px] flex-col items-center justify-center gap-5 rounded-2xl border border-amber-500/30 bg-slate-950/60 px-8 py-16 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-amber-500/15 text-amber-400">
        <ShieldOff className="h-7 w-7" aria-hidden />
      </div>
      <div>
        <h2 className="text-xl font-semibold text-white">{title}</h2>
        <p className="mt-2 max-w-md text-sm text-slate-400">{detail}</p>
      </div>
      <Link
        to="/admin/dashboard"
        className="rounded-xl border border-slate-600 bg-slate-800 px-5 py-2.5 text-sm font-medium text-white transition hover:bg-slate-700"
      >
        Retour au tableau de bord
      </Link>
    </div>
  );
}
